module.exports = __webpack_public_path__ + "img/google-play-store-btn-POLAND-pl.85d233d5.svg";